import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import axios from 'axios';
import { faPlus, faClock, faChevronDown, faCog, faRobot, faEnvelope, faSignOutAlt, faChevronRight, faUser, faBaby, faBucket, faBullhorn, faBullseye, faInbox, faStar } from '@fortawesome/free-solid-svg-icons';
import { getRecentChats, getAllSessions } from '../api/api';
import '../styles/sideBar.css';
import { UserContext } from './context/userContext';
import moment from 'moment';
import { useNavigate, useLocation } from 'react-router-dom';
import { deleteBabuChatSession, updateSessionDetails } from '../api/babuApi';
import { FaPencilAlt, FaTrash } from 'react-icons/fa';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { FaLinkedin, FaBlog, FaSearch, FaBullseye, FaVideo, FaComments,FaEnvelope, FaBullhorn, FaBox, FaChartBar } from 'react-icons/fa';
import { getWriterAiSessions } from '../api/writeraiApi';


const Sidebar = ({
    onLogout,
    onNewChat,
    userId,
    recentChats,
    activeSessionId,
    onChatSelect,
    onWriterAiChatSelect,  // Remove the default value
    toggleSidebar,
    favouriteChats
}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [user, setUser] = useState(null);
    const [isAccordionOpen, setIsAccordionOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState('');
    const [linkInput, setLinkInput] = useState('');
    const [isRecentsOpen, setIsRecentsOpen] = useState(false);
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const sessionType = "4"
    const [showAllChats, setShowAllChats] = useState(false);
    const [isProspectAIOpen, setIsProspectAIOpen] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState(null);
    const [editingChatId, setEditingChatId] = useState(null);
    const [editedTitle, setEditedTitle] = useState('');
    const [visibleChats, setVisibleChats] = useState([]);
    const [isWriterAIRecentsOpen, setIsWriterAIRecentsOpen] = useState(false);
    const [showWriterAIChatTypes, setShowWriterAIChatTypes] = useState(false);
    const [selectedWriterAIType, setSelectedWriterAIType] = useState(null);
    const [writerAiSessions, setWriterAiSessions] = useState({});
    const [isLoadingWriterAi, setIsLoadingWriterAi] = useState(false);
    const [openContentType, setOpenContentType] = useState(null);
    const [activeSessionDropdown, setActiveSessionDropdown] = useState(null);
    const [editingSessionId, setEditingSessionId] = useState(null);
    const [editedSessionTitle, setEditedSessionTitle] = useState('');
    const [isActionPointOpen, setIsActionPointOpen] = useState(false);
    const [isInboxOpen, setIsInboxOpen] = useState(false);
    const [isFavoriteOpen, setIsFavoriteOpen] = useState(false);
    const [favoriteChats, setFavoriteChats] = useState([]);
    const [regularChats, setRegularChats] = useState([]);
    const [isLoadingChats, setIsLoadingChats] = useState(false);
    const [allSessions, setAllSessions] = useState([]);
    console.log("favouriteChats--->", favouriteChats)
    console.log("regularChats--->", regularChats)

    const contentTypes = [
        { id: 'linkedin', name: 'LinkedIn Post', icon: <FaLinkedin />, description: 'Professional networking updates and thought leadership' },
        { id: 'blog', name: 'Blog Article', icon: <FaBlog />, description: 'In-depth articles and blog posts' },
        { id: 'seo', name: 'SEO Article', icon: <FaSearch />, description: 'Search engine optimized content with keyword targeting' },
        { id: 'landing', name: 'Landing Page', icon: <FaBullseye />, description: 'Conversion-focused landing page copy' },
        { id: 'video', name: 'Video Script', icon: <FaVideo />, description: 'Engaging video content scripts' },
        { id: 'social', name: 'Social Media Post', icon: <FaComments />, description: 'Engaging social media content' },
        { id: 'email', name: 'Email Campaign', icon: <FaEnvelope />, description: 'Email marketing campaigns' },
        { id: 'ad', name: 'Ad Copy', icon: <FaBullhorn />, description: 'Compelling advertising copy' },
        { id: 'product', name: 'Product Description', icon: <FaBox />, description: 'Detailed product descriptions' },
        { id: 'case', name: 'Case Study', icon: <FaChartBar />, description: 'In-depth case studies and whitepapers' },
        { id: 'custom-content', name: 'Custom Content', icon: <FaPencilAlt />, description: 'Custom content' }
    ];
    const ALL_CONTENT_TYPES = [
        'LinkedIn Post',
        'Blog Article',
        'SEO Article',
        'Landing Page',
        'Video Script',
        'Social Media Post',
        'Email Campaign',
        'Ad Copy',
        'Product Description',
        'Case Study',
        'Custom Content'
    ];

    // useEffect(() => {
    //     if (user && user.userId) {
    //       fetchRecentChats();
    //     }
    //   }, [user]);
    // console.log("recentChats--->", recentChats);

    useEffect(() => {
        const fetchWriterAiSessions = async () => {
            if (user && user.userId) {
                setIsLoadingWriterAi(true);
                try {
                    const response = await getWriterAiSessions(user.userId, "writerAi");
                    const processedSessions = processWriterAiSessions(response.data);
                    setWriterAiSessions(processedSessions);
                } catch (error) {
                    console.error('Error fetching Writer AI sessions:', error);
                } finally {
                    setIsLoadingWriterAi(false);
                }
            }
        };

        fetchWriterAiSessions();
    }, [user]);



    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem('user'));
        setUser(userData);
    }, []);

    useEffect(() => {
        if (recentChats && recentChats.length > 0) {
            const favorites = favouriteChats;
            const regular = recentChats;
            setFavoriteChats(favorites);
            setRegularChats(regular);
            setVisibleChats(showAllChats ? regular : regular.slice(0, 5));
        }
    }, [recentChats, showAllChats]);

    const handleMouseEnter = () => {
        setIsSidebarOpen(true);
    };

    const handleMouseLeave = () => {
        setIsSidebarOpen(false);
    };


    const handleRecentChatClick = (sessionId) => {
        console.log("Recent chat clicked. SessionId:", sessionId);
        console.log("Current location:", location.pathname);
        const newPath = `/chat/${sessionId}`;
        console.log("New path:", newPath);
        if (location.pathname !== newPath) {
            console.log("Navigating to:", newPath);
            navigate(newPath, { replace: true });
        } else {
            console.log("Already on the correct path, not navigating.");
        }
    };

    const toggleContentType = (contentType, e) => {
        e.stopPropagation();
        setOpenContentType(openContentType === contentType ? null : contentType);
    };

    const toggleSessionOptions = (e, sessionId) => {
        e.stopPropagation();
        setActiveSessionDropdown(activeSessionDropdown === sessionId ? null : sessionId);
    };

    const handleSessionRename = (sessionId, currentTitle) => {
        setEditingSessionId(sessionId);
        setEditedSessionTitle(currentTitle);
        setActiveSessionDropdown(null);
    };

    const handleSessionDelete = async (sessionId, contentType) => {
        try {
            // Add your delete API call here
            const updatedSessions = { ...writerAiSessions };
            delete updatedSessions[contentType][sessionId];
            setWriterAiSessions(updatedSessions);
        } catch (error) {
            console.error('Error deleting session:', error);
        }
    };

    const saveSessionTitle = async (sessionId, contentType) => {
        // Add your rename API call here
        setEditingSessionId(null);
        setEditedSessionTitle('');
    };


    const toggleRecents = () => {
        setIsRecentsOpen(!isRecentsOpen);
        if (!isRecentsOpen) {
            setShowAllChats(false);
        }
    };
    const toggleShowAllChats = async () => {
        if (!showAllChats) {
            setIsLoadingChats(true);
            try {
                const response = await getAllSessions(user.userId, "4");
                setAllSessions(response);
                setShowAllChats(true);
            } catch (error) {
                console.error('Error fetching all sessions:', error);
            } finally {
                setIsLoadingChats(false);
            }
        } else {
            setShowAllChats(false);
        }
    };
    // let visibleChats = showAllChats ? recentChats : recentChats.slice(0, 5);
    useEffect(() => {
        setVisibleChats(showAllChats ? recentChats : recentChats.slice(0, 5));
    }, [showAllChats, recentChats]);

    const toggleProspectAI = () => setIsProspectAIOpen(!isProspectAIOpen);

    const handleProspectAIClick = (e) => {
        // Check if the click is on the chevron icon
        if (e.target.closest('.accordion-icon')) {
            // If clicking the chevron, just toggle
            setIsProspectAIOpen(!isProspectAIOpen);
        } else {
            // If clicking elsewhere in the header, navigate
            navigate('/chat');
        }
    };

    const toggleAccordion = () => setIsAccordionOpen(!isAccordionOpen);

    const handleOptionChange = (e) => {
        setSelectedOption(e.target.value);
    };

    const handleLinkInputChange = (e) => {
        setLinkInput(e.target.value);
    };

    const handleFileUpload = (e) => {
        // Handle file upload logic here
        console.log('File uploaded:', e.target.files);
    };

    function navigateToRoute(route) {
        navigate(route)
    }

    const handleWriterAIClick = () => {
        // Preserve the current state of Prospect AI recents
        const currentProspectAIState = isProspectAIOpen;
        const currentRecentsState = isRecentsOpen;
        
        navigate('/writer-ai');
        
        // Restore the states after navigation
        setIsProspectAIOpen(currentProspectAIState);
        setIsRecentsOpen(currentRecentsState);
    };

    const toggleWriterAIRecents = (e) => {
        e.stopPropagation(); // Prevent navigation
        setIsWriterAIRecentsOpen(!isWriterAIRecentsOpen);
    };

    const toggleWriterAIChatTypes = () => {
        setShowWriterAIChatTypes(!showWriterAIChatTypes);
    };

    const toggleChatTypeContent = (typeId, e) => {
        e.stopPropagation();
        setSelectedWriterAIType(selectedWriterAIType === typeId ? null : typeId);
    };

    const processWriterAiSessions = (data) => {
        const sessions = {};

        // Initialize all content types with empty objects
        ALL_CONTENT_TYPES.forEach(type => {
            sessions[type] = {};
        });

        // Group messages by SessionId
        data.forEach(item => {
            const sessionId = item.SessionId;
            const contentType = item.chat_content_type;

            if (!sessions[contentType]) {
                sessions[contentType] = {};
            }

            if (!sessions[contentType][sessionId]) {
                sessions[contentType][sessionId] = [];
            }

            // Parse the History string to JSON
            const historyData = JSON.parse(item.History);
            sessions[contentType][sessionId].push({
                ...item,
                historyData
            });
        });

        // Sort messages within each session by _id
        Object.keys(sessions).forEach(contentType => {
            Object.keys(sessions[contentType]).forEach(sessionId => {
                sessions[contentType][sessionId].sort((a, b) => a._id.localeCompare(b._id));
            });
        });

        return sessions;
    };

    const getContentTypeId = (contentTypeName) => {
        const contentType = contentTypes.find(type => type.name === contentTypeName);
        return contentType ? contentType.id : contentTypeName.toLowerCase().replace(/\s+/g, '-');
    };

    const handleWriterAiSessionClick = (sessionId, contentType, e) => {
        e.preventDefault();
        e.stopPropagation();

        const contentTypeId = getContentTypeId(contentType);
        const path = `/writer-ai/${contentTypeId}/${sessionId}`;

        console.log('Navigating to:', path);
        navigate(path);
    };

    const extractMainIntent = (content) => {
        if (!content) return 'Untitled Chat';

        const words = content.split(' ');
        const shortIntent = words.slice(0, 5).join(' ');
        return words.length > 5 ? `${shortIntent}...` : shortIntent;
    };

    const getChatTitle = (chat) => {
        if (chat.chat_name) return chat.chat_name;
        const content = chat.messages?.[0]?.data?.content;
        if (typeof content === 'string') return content;
        return 'Untitled Chat';
    };

    const formatDate = (date) => {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
            "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const d = new Date(date);
        const day = d.getDate().toString().padStart(2, '0');
        const month = monthNames[d.getMonth()];
        let hours = d.getHours();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        const minutes = d.getMinutes().toString().padStart(2, '0');

        return {
            datePart: `${day} ${month}`,
            timePart: `${hours}:${minutes} ${ampm}`
        };
    };

    const toggleDropdown = () => setIsDropdownOpen(!isDropdownOpen);

    const getAvatarContent = () => {
        console.log('user----->', user)
        if (!user) return '';
        if (user.profilePic) return <img src={user.profilePic} alt="User avatar" className="user-avatar-img" />;
        return user.name.charAt(0).toUpperCase();
      };

    const handleAccountSettings = () => {
        navigate('/profile/settings');
    }
    const handleProfileClick = () => {
        navigate('/profile');
    }
    const handleApplicationTesting = () => {
        navigate('/application-testing');
    }
    const handleWriterAiTesting = () => {
        navigate('/writer-ai');
    }

    const toggleDropdownOptions = (event, chatId) => {
        event.stopPropagation();  // Prevent triggering onClick of the chat item
        setActiveDropdown(activeDropdown === chatId ? null : chatId);
    };

    const handleRename = (chatId, currentTitle) => {
        setEditingChatId(chatId);
        setEditedTitle(currentTitle || 'Untitled Chat');
        setActiveDropdown(null);
    };

    const handleTitleChange = (e) => {
        setEditedTitle(e.target.value);
    };

    const saveTitle = async (chatId) => {
        const updatedChats = visibleChats.map((chat) =>
            chat._id === chatId ? { ...chat, chat_name: editedTitle } : chat
        );
        setVisibleChats(updatedChats);
        const payload = {
            query:{_id:chatId},
            updateDocumnet:{
              chat_name:editedTitle,         
               }
          }
        await updateSessionDetails(payload);
        setEditingChatId(null);
        setEditedTitle('');
    };

    const handleDelete = async (chatId) => {
        // Add Confirmation Modal to delete
        const updatedChats = visibleChats.filter(chat => chat._id !== chatId);
        setVisibleChats(updatedChats);
        await deleteBabuChatSession({ sessionId: chatId });
        console.log('Deleted chat with ID:', chatId);
    };

    const handleKeyDown = (e, chatId) => {
        if (e.key === 'Enter') {
            saveTitle(chatId);
        }
    };

    const toggleActionPoint = () => {
        setIsActionPointOpen(!isActionPointOpen);
    };

    const handleActionPointClick = () => {
        navigate('/action-point');
    };

    const toggleInbox = () => {
        setIsInboxOpen(!isInboxOpen);
    };

    const toggleFavorites = () => {
        setIsFavoriteOpen(!isFavoriteOpen);
    };

    return (
        <>
            <div
                className="sidebar-trigger"
                style={{
                    position: 'fixed',
                    left: 0,
                    top: 0,
                    width: '10px',
                    height: '100%',
                    zIndex: 100
                }}
                onMouseEnter={handleMouseEnter}
            ></div>

            <div
                className={`sidebar ${isSidebarOpen ? 'open' : ''}`}
                onMouseLeave={handleMouseLeave}
            >
                <div className='sidebar-header-wrapper'>
                    <h1 className="sidebar-headr">getSalesGPT</h1>
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="menu-icon sidebar-menu-icon"
                        onClick={toggleSidebar}
                    >
                        <rect x="3" y="4" width="18" height="16" rx="2" stroke="currentColor" strokeWidth="2" />
                        <path d="M9 4V20" stroke="currentColor" strokeWidth="2" />
                    </svg>
                </div>
                <button className="new-chat-btn" onClick={onNewChat}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" class="!size-6"><path d="M15.6729 3.91287C16.8918 2.69392 18.8682 2.69392 20.0871 3.91287C21.3061 5.13182 21.3061 7.10813 20.0871 8.32708L14.1499 14.2643C13.3849 15.0293 12.3925 15.5255 11.3215 15.6785L9.14142 15.9899C8.82983 16.0344 8.51546 15.9297 8.29289 15.7071C8.07033 15.4845 7.96554 15.1701 8.01005 14.8586L8.32149 12.6785C8.47449 11.6075 8.97072 10.615 9.7357 9.85006L15.6729 3.91287ZM18.6729 5.32708C18.235 4.88918 17.525 4.88918 17.0871 5.32708L11.1499 11.2643C10.6909 11.7233 10.3932 12.3187 10.3014 12.9613L10.1785 13.8215L11.0386 13.6986C11.6812 13.6068 12.2767 13.3091 12.7357 12.8501L18.6729 6.91287C19.1108 6.47497 19.1108 5.76499 18.6729 5.32708ZM11 3.99929C11.0004 4.55157 10.5531 4.99963 10.0008 5.00007C9.00227 5.00084 8.29769 5.00827 7.74651 5.06064C7.20685 5.11191 6.88488 5.20117 6.63803 5.32695C6.07354 5.61457 5.6146 6.07351 5.32698 6.63799C5.19279 6.90135 5.10062 7.24904 5.05118 7.8542C5.00078 8.47105 5 9.26336 5 10.4V13.6C5 14.7366 5.00078 15.5289 5.05118 16.1457C5.10062 16.7509 5.19279 17.0986 5.32698 17.3619C5.6146 17.9264 6.07354 18.3854 6.63803 18.673C6.90138 18.8072 7.24907 18.8993 7.85424 18.9488C8.47108 18.9992 9.26339 19 10.4 19H13.6C14.7366 19 15.5289 18.9992 16.1458 18.9488C16.7509 18.8993 17.0986 18.8072 17.362 18.673C17.9265 18.3854 18.3854 17.9264 18.673 17.3619C18.7988 17.1151 18.8881 16.7931 18.9393 16.2535C18.9917 15.7023 18.9991 14.9977 18.9999 13.9992C19.0003 13.4469 19.4484 12.9995 20.0007 13C20.553 13.0004 21.0003 13.4485 20.9999 14.0007C20.9991 14.9789 20.9932 15.7808 20.9304 16.4426C20.8664 17.116 20.7385 17.7136 20.455 18.2699C19.9757 19.2107 19.2108 19.9756 18.27 20.455C17.6777 20.7568 17.0375 20.8826 16.3086 20.9421C15.6008 21 14.7266 21 13.6428 21H10.3572C9.27339 21 8.39925 21 7.69138 20.9421C6.96253 20.8826 6.32234 20.7568 5.73005 20.455C4.78924 19.9756 4.02433 19.2107 3.54497 18.2699C3.24318 17.6776 3.11737 17.0374 3.05782 16.3086C2.99998 15.6007 2.99999 14.7266 3 13.6428V10.3572C2.99999 9.27337 2.99998 8.39922 3.05782 7.69134C3.11737 6.96249 3.24318 6.3223 3.54497 5.73001C4.02433 4.7892 4.78924 4.0243 5.73005 3.54493C6.28633 3.26149 6.88399 3.13358 7.55735 3.06961C8.21919 3.00673 9.02103 3.00083 9.99922 3.00007C10.5515 2.99964 10.9996 3.447 11 3.99929Z" fill="currentColor"></path></svg>
                   <p className='start-new-chat'> Start New Chat </p>
                </button>
                <div className="sidebar-apps-content">

                    {/* Prospect AI Section */}
                    <div className="sidebar-section">
                        <h3 onClick={handleProspectAIClick} className="accordion-header prospect-ai-header">
                            <FontAwesomeIcon icon={faRobot} /> Prospect Finder
                            <FontAwesomeIcon
                                icon={faChevronRight}
                                className={`accordion-icon ${isProspectAIOpen ? 'open' : ''}`}
                            />
                        </h3>
                        <div className={`accordion-content-main ${isProspectAIOpen ? 'open' : ''}`}>
                            {/* Add Favorite Chats section */}
                            {favoriteChats.length > 0 && (
                                <div className="sidebar-section favorite-chat-section">
                                    <h3 onClick={toggleFavorites} className="accordion-header favorite-chat-header">
                                        <FontAwesomeIcon icon={faStar} /> Favorites
                                        <FontAwesomeIcon
                                            icon={faChevronRight}
                                            className={`accordion-icon ${isFavoriteOpen ? 'open' : ''}`}
                                        />
                                    </h3>
                                    <div className={`accordion-content ${isFavoriteOpen ? 'open' : ''}`}>
                                        <ul className="chat-list">
                                            {favoriteChats.map((chat) => (
                                                <li
                                                    key={chat._id}
                                                    className={`chat-item ${chat._id === activeSessionId ? 'active' : ''}`}
                                                    onClick={() => onChatSelect(chat._id)}
                                                >
                                                    <div className="chat-content">
                                                        <span className="chat-intent">
                                                            {editingChatId === chat._id ? (
                                                                <input
                                                                    type="text"
                                                                    value={editedTitle}
                                                                    onChange={handleTitleChange}
                                                                    onBlur={() => saveTitle(chat._id)}
                                                                    onKeyDown={(e) => handleKeyDown(e, chat._id)}
                                                                    autoFocus
                                                                />
                                                            ) : (
                                                                getChatTitle(chat)
                                                            )}
                                                        </span>
                                                        <div className="chat-timestamp">
                                                            <div>{formatDate(chat.messages && chat.messages[0]?.data.time).datePart}</div>
                                                            <div>{formatDate(chat.messages && chat.messages[0]?.data.time).timePart}</div>
                                                        </div>
                                                        <div className="edit-chat-options">
                                                            <span style={{ cursor: 'pointer' }} onClick={(e) => toggleDropdownOptions(e, chat._id)}>⋮</span>
                                                            {activeDropdown === chat._id && (
                                                                <div className="dropdown-menu-chat-options">
                                                                    <button onClick={() => handleRename(chat._id, getChatTitle(chat))}>
                                                                        <FaPencilAlt style={{ marginRight: '15px' }} /> Rename
                                                                    </button>
                                                                    <button onClick={() => handleDelete(chat._id)} style={{ color: '#f93a37' }}>
                                                                        <FaTrash style={{ marginRight: '15px' }} /> Delete
                                                                    </button>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            )}

                            {/* Existing Recents section - now using regularChats instead of recentChats */}
                            <div className="sidebar-section recents-section">
                                <h3 onClick={toggleRecents} className="accordion-header recents-header">
                                    <FontAwesomeIcon icon={faClock} /> Recents
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className={`accordion-icon ${isRecentsOpen ? 'open' : ''}`}
                                    />
                                </h3>
                                <div className={`accordion-content ${isRecentsOpen ? 'open' : ''} ${showAllChats ? 'show-all' : ''}`}>
                                    {isLoadingChats ? (
                                        <div className="loading-spinner">
                                            <div className="spinner spinner-chat"></div>
                                            <p className="loading-text"></p>
                                        </div>
                                    ) : (
                                        <>
                                            <ul className="chat-list">
                                                {showAllChats && allSessions.length > 0 ? (
                                                    allSessions.map((chat) => (
                                                        <li
                                                            key={chat._id}
                                                            className={`chat-item ${chat._id === activeSessionId ? 'active' : ''}`}
                                                            onClick={() => onChatSelect(chat._id)}
                                                        >
                                                            <div className="chat-content">
                                                                <span className="chat-intent">
                                                                    {editingChatId === chat._id ? (
                                                                        <input
                                                                            type="text"
                                                                            value={editedTitle}
                                                                            onChange={handleTitleChange}
                                                                            onBlur={() => saveTitle(chat._id)}
                                                                            onKeyDown={(e) => handleKeyDown(e, chat._id)}
                                                                            autoFocus
                                                                        />
                                                                    ) : (
                                                                        getChatTitle(chat)
                                                                    )}
                                                                </span>
                                                                <div className="chat-timestamp">
                                                                    <div>{formatDate(chat.messages && chat.messages[0]?.data.time).datePart}</div>
                                                                    <div>{formatDate(chat.messages && chat.messages[0]?.data.time).timePart}</div>
                                                                </div>
                                                                <div className="edit-chat-options">
                                                                    <span style={{ cursor: 'pointer' }} onClick={(e) => toggleDropdownOptions(e, chat._id)}>⋮</span>
                                                                    {activeDropdown === chat._id && (
                                                                        <div className="dropdown-menu-chat-options">
                                                                            <button onClick={() => handleRename(chat._id, getChatTitle(chat))}>
                                                                                <FaPencilAlt style={{ marginRight: '15px' }} /> Rename
                                                                            </button>
                                                                            <button onClick={() => handleDelete(chat._id)} style={{ color: '#f93a37' }}>
                                                                                <FaTrash style={{ marginRight: '15px' }} /> Delete
                                                                            </button>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </li>
                                                    ))
                                                ) : (
                                                    regularChats.slice(0, 5).map((chat) => (
                                                        <li
                                                            key={chat._id}
                                                            className={`chat-item ${chat._id === activeSessionId ? 'active' : ''}`}
                                                            onClick={() => onChatSelect(chat._id)}
                                                        >
                                                            <div className="chat-content">
                                                                <span className="chat-intent">
                                                                    {editingChatId === chat._id ? (
                                                                        <input
                                                                            type="text"
                                                                            value={editedTitle}
                                                                            onChange={handleTitleChange}
                                                                            onBlur={() => saveTitle(chat._id)}
                                                                            onKeyDown={(e) => handleKeyDown(e, chat._id)}
                                                                            autoFocus
                                                                        />
                                                                    ) : (
                                                                        getChatTitle(chat)
                                                                    )}
                                                                </span>
                                                                <div className="chat-timestamp">
                                                                    <div>{formatDate(chat.messages && chat.messages[0]?.data.time).datePart}</div>
                                                                    <div>{formatDate(chat.messages && chat.messages[0]?.data.time).timePart}</div>
                                                                </div>
                                                                <div className="edit-chat-options">
                                                                    <span style={{ cursor: 'pointer' }} onClick={(e) => toggleDropdownOptions(e, chat._id)}>⋮</span>
                                                                    {activeDropdown === chat._id && (
                                                                        <div className="dropdown-menu-chat-options">
                                                                            <button onClick={() => handleRename(chat._id, getChatTitle(chat))}>
                                                                                <FaPencilAlt style={{ marginRight: '15px' }} /> Rename
                                                                            </button>
                                                                            <button onClick={() => handleDelete(chat._id)} style={{ color: '#f93a37' }}>
                                                                                <FaTrash style={{ marginRight: '15px' }} /> Delete
                                                                            </button>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </li>
                                                    ))
                                                )}
                                            </ul>
                                            {(showAllChats ? allSessions.length : regularChats.length) > 5 && isRecentsOpen && (
                                                <button 
                                                    className="view-all-btn" 
                                                    onClick={toggleShowAllChats}
                                                    disabled={isLoadingChats}
                                                >
                                                    {showAllChats ? 'View less ←' : 'View all →'}
                                                </button>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>

                            {/* Moved Custom Content section here */}
                            <div className="custom-context-section">
                                <h4 onClick={toggleAccordion}>
                                    Custom Content
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className={`accordion-icon ${isAccordionOpen ? 'open' : ''}`}
                                    />
                                </h4>
                                <div className={`accordion-content ${isAccordionOpen ? 'open' : ''}`}>
                                    <div className="accordion-inner">
                                        <div className="content-selector">
                                            <label htmlFor="content-dropdown">Add content:</label>
                                            <select id="content-dropdown">
                                                <option value="">Select Content Type</option>
                                                <option value="option1">Option 1</option>
                                                <option value="option2">Option 2</option>
                                                <option value="option3">Option 3</option>
                                                <option value="option4">Option 4</option>
                                            </select>
                                        </div>
                                        <div className="radio-options">
                                            <label>
                                                <input
                                                    className='radio-input'
                                                    type="radio"
                                                    value="onepgr"
                                                    checked={selectedOption === 'onepgr'}
                                                    onChange={handleOptionChange}
                                                />
                                                OnePgr
                                            </label>
                                            <label>
                                                <input
                                                    type="radio"
                                                    value="upload"
                                                    checked={selectedOption === 'upload'}
                                                    onChange={handleOptionChange}
                                                />
                                                Upload
                                            </label>
                                            <label>
                                                <input
                                                    type="radio"
                                                    value="addLink"
                                                    checked={selectedOption === 'addLink'}
                                                    onChange={handleOptionChange}
                                                />
                                                URL
                                            </label>
                                        </div>
                                        {selectedOption === 'addLink' && (
                                            <div className="link-input">
                                                <input
                                                    type="text"
                                                    value={linkInput}
                                                    onChange={handleLinkInputChange}
                                                    placeholder="Enter link"
                                                />
                                                <button className='add-btn-url'>Add</button>
                                            </div>
                                        )}
                                        {selectedOption === 'upload' && (
                                            <div className="file-upload-area">
                                                <input
                                                    type="file"
                                                    id="file-upload"
                                                    onChange={handleFileUpload}
                                                    style={{ display: 'none' }}
                                                />
                                                <label htmlFor="file-upload" className="file-upload-label">
                                                    Drop your files here
                                                </label>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="custom-context-section">
                        <h4 onClick={() => { navigateToRoute('/ai-campaign') }}>
                            <FontAwesomeIcon icon={faBullhorn} className="ai-campaign-icon" />
                            AI Campaign
                        </h4>
                    </div>

                    {/* <div className="custom-context-section">
                        <h4 onClick={handleApplicationTesting}>
                            Application-testing
                        </h4>
                    </div> */}
                    <div className="custom-context-section writer-ai-section">
                        <div className="accordion-header writer-ai-main-header">
                            <div className="writer-ai-title" onClick={handleWriterAIClick}>
                                <FontAwesomeIcon icon={faEdit} className="writer-ai-icon" />
                                <h4>Writer AI</h4>
                            </div>
                            <FontAwesomeIcon
                                icon={faChevronRight}
                                className={`accordion-icon ${isWriterAIRecentsOpen ? 'open' : ''}`}
                                onClick={toggleWriterAIRecents}
                            />
                        </div>
                        <div className={`accordion-content-main ${isWriterAIRecentsOpen ? 'open' : ''}`}>
                            {/* Recents Section */}
                            <div className="sidebar-section writer-ai-section">
                                <div className="accordion-header recents-header" onClick={toggleWriterAIChatTypes}>
                                    <div className="recents-title">
                                        <FontAwesomeIcon icon={faClock} />
                                        <span>Recents</span>
                                    </div>
                                    <FontAwesomeIcon
                                        icon={faChevronRight}
                                        className={`accordion-icon ${showWriterAIChatTypes ? 'open' : ''}`}
                                    />
                                </div>

                                <div className={`accordion-content ${showWriterAIChatTypes ? 'open' : ''}`}>
                                    {isLoadingWriterAi ? (
                                        <div className="loading-message">Loading sessions...</div>
                                    ) : (
                                        ALL_CONTENT_TYPES.map((contentType) => (
                                            <div key={contentType} className="writer-ai-content-type">
                                                <div
                                                    className="content-type-header"
                                                    onClick={(e) => toggleContentType(contentType, e)}
                                                >
                                                    <div className="content-type-info">
                                                        <span>{contentType}</span>
                                                    </div>
                                                    <FontAwesomeIcon
                                                        icon={faChevronRight}
                                                        className={`accordion-icon ${openContentType === contentType ? 'open' : ''}`}
                                                    />
                                                </div>
                                                <div className={`content-type-sessions ${openContentType === contentType ? 'open' : ''}`}>
                                                    {Object.entries(writerAiSessions[contentType] || {}).length > 0 ? (
                                                        Object.entries(writerAiSessions[contentType]).map(([sessionId, messages]) => {
                                                            const firstMessage = messages.find(msg =>
                                                                JSON.parse(msg.History).type === 'human'
                                                            );
                                                            const title = firstMessage ?
                                                                JSON.parse(firstMessage.History).data.content :
                                                                'Untitled Chat';

                                                            const date = formatDate(new Date(sessionId.split('_')[0]));

                                                            return (
                                                                <div
                                                                    key={sessionId}
                                                                    className="writer-ai-session"
                                                                    onClick={(e) => handleWriterAiSessionClick(sessionId, contentType, e)}
                                                                >
                                                                    <div className="session-content">
                                                                        <div className="session-left">
                                                                            {editingSessionId === sessionId ? (
                                                                                <input
                                                                                    type="text"
                                                                                    value={editedSessionTitle}
                                                                                    onChange={(e) => setEditedSessionTitle(e.target.value)}
                                                                                    onBlur={() => saveSessionTitle(sessionId, contentType)}
                                                                                    onKeyDown={(e) => {
                                                                                        if (e.key === 'Enter') {
                                                                                            saveSessionTitle(sessionId, contentType);
                                                                                        }
                                                                                    }}
                                                                                    onClick={(e) => e.stopPropagation()}
                                                                                    autoFocus
                                                                                    className="session-title-input"
                                                                                />
                                                                            ) : (
                                                                                <span className="session-title">{title}</span>
                                                                            )}
                                                                        </div>
                                                                        <div className="session-right">
                                                                            <div className="session-time">
                                                                                <div className="time-date">{date.datePart}</div>
                                                                                <div className="time-hour">{date.timePart}</div>
                                                                            </div>
                                                                            <div className="session-options">
                                                                                <span
                                                                                    className="options-trigger"
                                                                                    onClick={(e) => toggleSessionOptions(e, sessionId)}
                                                                                >
                                                                                    ⋮
                                                                                </span>
                                                                                {activeSessionDropdown === sessionId && (
                                                                                    <div className="session-dropdown-menu">
                                                                                        <button onClick={(e) => {
                                                                                            e.stopPropagation();
                                                                                            handleSessionRename(sessionId, title);
                                                                                        }}>
                                                                                            <FaPencilAlt className="button-icon" /> Rename
                                                                                        </button>
                                                                                        <button
                                                                                            onClick={(e) => {
                                                                                                e.stopPropagation();
                                                                                                handleSessionDelete(sessionId, contentType);
                                                                                            }}
                                                                                            className="delete-button"
                                                                                        >
                                                                                            <FaTrash className="button-icon" /> Delete
                                                                                        </button>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            );
                                                        })
                                                    ) : (
                                                        <div className="no-sessions-message">No recent chats</div>
                                                    )}
                                                </div>
                                            </div>
                                        ))
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Action Point Section */}
                    <div className="custom-context-section action-point-section">
                        <div className="accordion-header action-point-main-header">
                            <div className="action-point-title" onClick={handleActionPointClick}>
                                <FontAwesomeIcon icon={faBullseye} className="writer-ai-icon" />
                                <h4>Action Point</h4>
                            </div>
                            <FontAwesomeIcon
                                icon={faChevronRight}
                                className={`accordion-icon ${isActionPointOpen ? 'open' : ''}`}
                                onClick={toggleActionPoint}
                            />
                        </div>
                        <div className={`accordion-content-main ${isActionPointOpen ? 'open' : ''}`}>
                            {/* Add your Action Point content here */}
                            <div className="sidebar-section action-point-section">
                                <div className="accordion-header recents-header">
                                    <div className="recents-title">
                                        <FontAwesomeIcon icon={faClock} />
                                        <span>Recents</span>
                                    </div>
                                </div>
                                <div className="accordion-content">
                                    {/* Add your recent Action Point items here */}
                                    <p>No recent action points to show</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div className="custom-context-section inbox-section">
                        <div className="accordion-header inbox-main-header" onClick={() => navigateToRoute('/inbox')}>
                            <div className="inbox-title" >
                                <FontAwesomeIcon icon={faInbox} className="box-icon" />
                                <h4>Inbox</h4>
                            </div>
                        </div>
                     
                    </div> */}
                </div>

                <div className="sidebar-footer">
                    {user && (
                        <div className="user-info" onClick={toggleDropdown}>
                            <div className="user-avatar">
                                {getAvatarContent()}
                            </div>
                            <div className="user-email">{user.name}</div>
                            <FontAwesomeIcon icon={faChevronDown} className={`dropdown-icon ${isDropdownOpen ? 'open' : ''}`} />
                        </div>
                    )}
                    {isDropdownOpen && (
                        <div className="profile-dropdown-menu">
                            <button onClick={handleProfileClick}><FontAwesomeIcon icon={faUser} />Profile</button>
                            <button onClick={handleAccountSettings}><FontAwesomeIcon icon={faCog} />Account Settings</button>
                            <button onClick={() => navigateToRoute('/profile/subscriptions')}><FontAwesomeIcon icon={faUser} />My Subscriptions</button>
                            <button onClick={onLogout}><FontAwesomeIcon icon={faSignOutAlt} /> Logout</button>
                        </div>
                    )}
                </div>

            </div>
        </>
    );
};

export default Sidebar;